export var PropertySearchOption;
(function (PropertySearchOption) {
    PropertySearchOption["Property"] = "Property";
    PropertySearchOption["PropertyOwner"] = "Owner";
    PropertySearchOption["PropertyZoning"] = "Zoning";
    PropertySearchOption["Cemetery"] = "Cemetery";
    PropertySearchOption["Grave"] = "Grave";
})(PropertySearchOption || (PropertySearchOption = {}));
